import { render, staticRenderFns } from "./HalfButton.vue?vue&type=template&id=12676a27&"
import script from "./HalfButton.vue?vue&type=script&lang=js&"
export * from "./HalfButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports